import { PhonicsActivity, PhonicsActivityTypeMode } from '@/api/types';

export interface ActivityTypeProps {
  activity: PhonicsActivity;
  wrapperClassName?: string;
  mode: PhonicsActivityTypeMode;
  isPreview?: boolean;
}

// Teach
export const ACTIVITY_TYPE_READING_REVIEW_SOUNDS_IDENTIFIER =
  'reading_review_sounds'; // ACTIVITY_TYPE_REVIEW_SOUND_READING_IDENTIFIER = 'review_sound_reading'
export const ACTIVITY_TYPE_READING_NEW_SOUNDS_IDENTIFIER = 'reading_new_sounds'; // ACTIVITY_TYPE_NEW_SOUND_READING_IDENTIFIER = 'new_sound_reading'
export const ACTIVITY_TYPE_READING_LISTENING_IDENTIFIER = 'reading_listening'; // ACTIVITY_TYPE_LISTENING_IDENTIFIER = 'listening'
export const ACTIVITY_TYPE_READING_ORAL_BLENDING_IDENTIFIER =
  'reading_oral_blending'; // ACTIVITY_TYPE_ORAL_BLENDING_IDENTIFIER = 'oral_blending'
export const ACTIVITY_TYPE_READING_MANIPULATING_SOUNDS_IDENTIFIER =
  'reading_manipulating_sounds'; // ACTIVITY_TYPE_MANIPULATING_SOUNDS_IDENTIFIER = 'manipulating_sounds'
export const ACTIVITY_TYPE_READING_READ_WORDS_IDENTIFIER = 'reading_read_words'; // ACTIVITY_TYPE_READING_WORDS_IDENTIFIER = 'reading_words'
export const ACTIVITY_TYPE_READING_TRICKY_WORDS_IDENTIFIER =
  'reading_tricky_words';
export const ACTIVITY_TYPE_READING_READ_SENTENCES_IDENTIFIER =
  'reading_read_sentences'; // ACTIVITY_TYPE_READING_SENTENCES_IDENTIFIER = 'reading_sentences'
export const ACTIVITY_TYPE_READING_FOCUS_SOUNDS_IDENTIFIER =
  'reading_focus_sounds';
export const ACTIVITY_TYPE_READING_CATEGORIZE_WORDS_IDENTIFIER =
  'reading_categorize_words';
export const ACTIVITY_TYPE_READING_SINGULAR_OR_PLURAL_IDENTIFIER =
  'reading_singular_or_plural';
export const ACTIVITY_TYPE_READING_ADD_SUFFIXES_IDENTIFIER =
  'reading_add_suffixes';
export const ACTIVITY_TYPE_READING_NEW_SUFFIX_IDENTIFIER = 'reading_new_suffix';
export const ACTIVITY_TYPE_READING_REVIEW_ROOT_WORDS_AND_SUFFIXES_IDENTIFIER =
  'reading_review_root_words_and_suffixes';
export const ACTIVITY_TYPE_READING_REVIEW_SUFFIX_IDENTIFIER =
  'reading_review_suffix';
export const ACTIVITY_TYPE_READING_FORM_THIRD_PERSON_SINGULAR_IDENTIFIER =
  'reading_form_third_person_singular';
export const ACTIVITY_TYPE_READING_MANIPULATING_PREFIXES_AND_SUFFIXES_IDENTIFIER =
  'reading_manipulating_prefixes_and_suffixes';
export const ACTIVITY_TYPE_READING_NOUN_OR_VERB_IDENTIFIER =
  'reading_noun_or_verb';
export const ACTIVITY_TYPE_READING_REVIEW_ROOT_WORDS_IDENTIFIER =
  'reading_review_root_words';

// Learn
export const ACTIVITY_TYPE_SPELLING_REVIEW_SOUNDS_IDENTIFIER =
  'spelling_review_sounds'; // ACTIVITY_TYPE_REVIEW_SOUND_SPELLING_IDENTIFIER = 'review_sound_spelling'
export const ACTIVITY_TYPE_SPELLING_NEW_SOUNDS_IDENTIFIER =
  'spelling_new_sounds'; // ACTIVITY_TYPE_NEW_SOUND_SPELLING_IDENTIFIER = 'new_sound_spelling'
export const ACTIVITY_TYPE_SPELLING_FLICKING_FINGERS_IDENTIFIER =
  'spelling_flicking_fingers'; // ACTIVITY_TYPE_FLICKING_PHONEME_FINGERS_IDENTIFIER = 'flicking_phoneme_fingers' // TODO: This should be 'spelling_oral_segmenting' but we need to keep the old name for now
export const ACTIVITY_TYPE_SPELLING_WRITE_WORDS_IDENTIFIER =
  'spelling_write_words'; // ACTIVITY_TYPE_WORD_DICTATION_IDENTIFIER = 'word_dictation'
export const ACTIVITY_TYPE_SPELLING_WRITE_SENTENCES_IDENTIFIER =
  'spelling_write_sentences'; // ACTIVITY_TYPE_SENTENCE_DICTATION_IDENTIFIER = 'sentence_dictation';
export const ACTIVITY_TYPE_SPELLING_FOCUS_SOUNDS_IDENTIFIER =
  'spelling_focus_sounds';
export const ACTIVITY_TYPE_SPELLING_REVIEW_ROOT_WORDS_AND_SUFFIXES_IDENTIFIER =
  'spelling_review_root_words_and_suffixes';
export const ACTIVITY_TYPE_SPELLING_WRITE_ROOT_WORD_IDENTIFIER =
  'spelling_write_root_word';
export const ACTIVITY_TYPE_SPELLING_REVISE_SUFFIX_SPELLING_IDENTIFIER =
  'spelling_revise_suffix_spelling';
export const ACTIVITY_TYPE_SPELLING_NOUN_OR_VERB_IDENTIFIER =
  'spelling_noun_or_verb';

// using old nomenclature
export const ACTIVITY_TYPE_SOUND_DICTATION_IDENTIFIER = 'sound_dictation';

export const READING_ACTIVITIES = [
  ACTIVITY_TYPE_READING_REVIEW_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_NEW_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_LISTENING_IDENTIFIER,
  ACTIVITY_TYPE_READING_ORAL_BLENDING_IDENTIFIER,
  ACTIVITY_TYPE_READING_MANIPULATING_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_READ_WORDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_READ_SENTENCES_IDENTIFIER,
  ACTIVITY_TYPE_READING_FOCUS_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_CATEGORIZE_WORDS_IDENTIFIER,
  ACTIVITY_TYPE_READING_SINGULAR_OR_PLURAL_IDENTIFIER,
  ACTIVITY_TYPE_READING_ADD_SUFFIXES_IDENTIFIER,
  ACTIVITY_TYPE_READING_NEW_SUFFIX_IDENTIFIER,
  ACTIVITY_TYPE_READING_REVIEW_ROOT_WORDS_AND_SUFFIXES_IDENTIFIER,
  ACTIVITY_TYPE_READING_REVIEW_SUFFIX_IDENTIFIER,
  ACTIVITY_TYPE_READING_FORM_THIRD_PERSON_SINGULAR_IDENTIFIER,
  ACTIVITY_TYPE_READING_MANIPULATING_PREFIXES_AND_SUFFIXES_IDENTIFIER,
  ACTIVITY_TYPE_READING_NOUN_OR_VERB_IDENTIFIER,
  ACTIVITY_TYPE_READING_REVIEW_ROOT_WORDS_IDENTIFIER,
];

export const SPELLING_ACTIVITIES = [
  ACTIVITY_TYPE_SPELLING_REVIEW_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_NEW_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_FLICKING_FINGERS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_WRITE_WORDS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_WRITE_SENTENCES_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_FOCUS_SOUNDS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_REVIEW_ROOT_WORDS_AND_SUFFIXES_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_REVISE_SUFFIX_SPELLING_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_NOUN_OR_VERB_IDENTIFIER,
];

export const NON_SCORING_SPELLING_ACTIVITIES = [
  ACTIVITY_TYPE_SPELLING_FLICKING_FINGERS_IDENTIFIER,
  ACTIVITY_TYPE_SPELLING_NOUN_OR_VERB_IDENTIFIER, // TODO: ???
];

export type PhonicsLessonPlayerKind = 'reading' | 'spelling';
